module.exports = __webpack_public_path__ + "static/media/salmon_lover_bowl.2c36007f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/dish_image/salmon_lover_bowl.jpg
// module id = 161
// module chunks = 0